import React, { useState } from "react";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What is Social Media Marketing?",
      answer: "Social Media Marketing is a digital strategy that uses platforms like Facebook and Instagram to promote brands, engage audiences, and generate leads.",
    },
    {
      question: "How does Social Media Marketing help businesses grow?",
      answer: "It helps increase brand awareness, drive website traffic, improve customer engagement, and generate quality leads and sales.",
    },
    {
      question: "Which platforms are best for Social Media Marketing?",
      answer: "Top platforms include Instagram, Facebook, LinkedIn, and YouTube depending on your target audience.",
    },
    {
      question: "How long does it take to see results from Social Media Marketing?",
      answer: "You can start seeing engagement within a few weeks, but strong results usually take 1–3 months with consistent strategy and posting.",
    },
    {
      question: "Is Social Media Marketing suitable for small businesses?",
      answer: "Yes, it is cost-effective and helps small businesses reach their target audience, build brand awareness, and increase sales.",
    },

  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="k-faq-section">
      <div className="k-faq-container">
        <h2 className="k-faq-heading">Frequently Asked Questions</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={
              activeIndex === index ? "k-faq-box active" : "k-faq-box"
            }
          >
            <div
              className="k-faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span className="k-faq-title">{item.question}</span>
              <span className="k-faq-arrow">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>

            <div className="k-faq-answer">
              <p className="k-faq-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;